/**
 * Serviço para buscar atributos do usuário do Cognito
 */

const COGNITO_USER_POOL_ID = 'us-east-1_sgMHVAasC';
const COGNITO_REGION = 'us-east-1';

/**
 * Busca atributos do usuário do Cognito usando o access token
 * @param accessToken Access token do usuário autenticado
 * @returns Atributos do usuário ou null em caso de erro
 */
export const fetchUserAttributes = async (accessToken: string): Promise<any | null> => {
  try {
    // Endpoint do userinfo do Cognito
    const userInfoUrl = `https://${COGNITO_USER_POOL_ID}.auth.${COGNITO_REGION}.amazoncognito.com/oauth2/userInfo`;
    
    const response = await fetch(userInfoUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.error('Erro ao buscar atributos do usuário:', response.status, response.statusText);
      return null;
    }

    const userInfo = await response.json();
    console.log('📋 UserInfo do Cognito:', userInfo);
    return userInfo;
  } catch (error) {
    console.error('Erro ao buscar atributos do usuário:', error);
    return null;
  }
};

/**
 * Busca atributos do usuário usando a API do Cognito Identity Provider
 * Requer o access token e retorna todos os atributos do usuário
 */
export const fetchUserAttributesFromCognito = async (accessToken: string): Promise<any | null> => {
  try {
    // Primeiro tenta o userinfo endpoint (mais simples)
    const userInfo = await fetchUserAttributes(accessToken);
    if (userInfo) {
      return userInfo;
    }

    // Se não funcionar, pode tentar outras abordagens
    console.warn('UserInfo endpoint não retornou dados, tentando alternativas...');
    return null;
  } catch (error) {
    console.error('Erro ao buscar atributos do Cognito:', error);
    return null;
  }
};



